export enum StepStatusEnum {
    PENDING = 'PENDING',
    PENDING_NEXT = 'PENDING_NEXT',
    CURRENT = 'CURRENT',
    COMPLETED = 'COMPLETED',
    SKIPPED = 'SKIPPED',
    UNKNOWN = 'UNKNOWN',
}
